import _ from 'lodash';
import css from 'styled-jsx/css';
import { colors, icons, typography } from '../../../../../config/styles';
import { svgToDataUri } from '../../../../../utils/styles/svgMixins';

const StoreListDetailsStyles = (theme) => {
  const secondaryColor = _.get(theme, 'secondary_color', null) || colors.secondary_color;
  // @ts-ignore
  return css`
    .details-container {
      display: flex;
      font-family: 'Lato', sans-serif;
      margin: 12px 16px 16px;

      @mixin mobileToTablet {
        background: ${colors.white.shade1};
        height: 100%;
        border-radius: 12px;
        margin: 10px 16px 16px;
      }
      &.selected {
        @mixin mobileToTablet {
          border-radius: 12px;
          border: 1px solid #343e49;
          background: #fefeff;
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        }
      }
    }
    .flex {
      display: flex;
      align-items: flex-start;
    }
    .separator {
      border-bottom: 1px solid ${colors.gray.shade68};
      margin: 20px 0 8px 0;
      &:last-child {
        display: none;
        margin: 20px 0 8px 0;
      }
      @mixin mobileToTablet {
        display: none;
      }
    }
    .lists-container {
      overflow-y: auto;
      height: 100%;
      @mixin mobileToTablet {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: auto;
        background: linear-gradient(180deg, rgba(51, 51, 51, 0) 0%, rgba(51, 51, 51, 0.7) 42.37%);
      }
      &.list-view {
        height: 80%;
        background: none;
        border-top: 1px solid ${colors.gray.shade14};
        @mixin mobileToTablet {
          position: relative;
          height: 100%;
        }
      }
      .store-box {
        border-bottom: 1px solid #c2c2c2;
        @mixin mobileToTablet {
          display: flex;
        }
        &.list-view {
          flex-direction: column;
        }
      }
    }
    span.hide-in-mobile {
      @mixin mobileToTablet {
        display: none;
      }
    }
    .selection-radio {
      width: 21px;
      height: 21px;
      margin: 7px 5px 0 0;
      @mixin mobileToTablet {
        display: none;
      }
    }
    .store-content {
      width: 100%;
      @mixin mobileToTablet {
        border-radius: 12px;
        background: #fefeff;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        width: 300px;
        padding: 16px;
        border-radius: 12px;
        background: #fefeff;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      }
      &.list-view {
        width: 100%;
      }
    }
    .name-address {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      width: 100%;
      p:first-child {
        color: #333;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        @mixin mobileToTablet {
          font-size: 16px;
        }
      }
      p:nth-of-type(2) {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        @mixin mobileToTablet {
          font-size: ${typography.sm};
          color: #333;
          font-size: 12px;
          line-height: 16px;
        }
      }
      .check-store-schedules {
        color: #343e49;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
      }
    }
    input[type='radio'] {
      accent-color: ${secondaryColor}; /* Supported in modern browsers */
    }
    .icon {
      display: block;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('/a/fa/product/static/styles/svg/fcomIcon.svg');
      width: 20px;
      height: 16px;
      margin-top: 2px;
    }
    .sodimac {
      background-image: url('/a/fa/product/static/styles/svg/sodimac.svg');
      width: 20px;
      height: 16px;
    }
    .tottus {
      background-image: url('/a/fa/product/static/styles/svg/tottus.svg');
      width: 22px;
      height: 20px;
    }
    .falabella {
      background-image: url('/a/fa/product/static/styles/svg/falabella.svg');
      width: 20px;
      height: 20px;
    }
    .plaza {
      background-image: url('/a/fa/product/static/styles/svg/mPlazaIcon.svg');
      width: 20px;
      height: 20px;
    }
    .chilexpress {
      background-image: url('/a/fa/product/static/styles/svg/chileExpressIcon.svg');
      width: 20px;
      height: 20px;
    }
    .bluexpress {
      background-image: url('/a/fa/product/static/styles/svg/blueexpressIcon.svg');
      width: 20px;
      height: 20px;
    }
    .metro {
      background-image: url('/a/fa/product/static/styles/svg/metroIcon.svg');
      width: 20px;
      height: 20px;
    }
    .etam {
      background-image: url('/a/fa/product/static/styles/svg/etamIcon.svg');
      width: 20px;
      height: 20px;
    }
    .sybilla {
      background-image: url('/a/fa/product/static/styles/svg/sybillaIcon.svg');
      width: 20px;
      height: 20px;
    }
    .americanino {
      background-image: url('/a/fa/product/static/styles/svg/americaninoIcon.svg');
      width: 20px;
      height: 20px;
    }
    .mango {
      background-image: url('/a/fa/product/static/styles/svg/mangoIcon.svg');
      width: 20px;
      height: 20px;
    }
    .aldo {
      background-image: url('/a/fa/product/static/styles/svg/aldoIcon.svg');
      width: 20px;
      height: 20px;
    }
    .clarks {
      background-image: url('/a/fa/product/static/styles/svg/clarksIcon.svg');
      width: 20px;
      height: 20px;
    }
    .carters {
      background-image: url('/a/fa/product/static/styles/svg/cartersIcon.svg');
      width: 20px;
      height: 20px;
    }
    .maestro {
      background-image: url('/a/fa/product/static/styles/svg/maestroIcon.svg');
      width: 26px;
      height: 12px;
    }
    .clock-icon {
      background-image: url('${svgToDataUri(icons.clock)}');
      width: 20px;
      height: 20px;
      margin-right: 4px;
      @mixin mobileToTablet {
        width: 24px;
        height: 20px;
        margin-top: 0;
      }
    }
    .cost-label {
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px;
      &.green-bold {
        color: ${colors.green.shade31};
      }
    }
    .working-text {
      margin--left: 4px;
    }
    .working-hours > p {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      color: ${colors.gray.shade52};
      margin-left: 4px;
    }
    .working-hours {
      margin-top: 10px;
      align-items: flex-start;
      @mixin mobileToTablet {
        margin-top: 9px;
      }
    }
    .delivery-dates {
      justify-content: space-between;
      padding-bottom: 8px;
      margin-top: 8px;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }
    .store-availability {
      margin-top: 5px;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      position: relative;
      @mixin mobileToTablet {
        line-height: normal;
        font-size: 12px;
      }
      &.available {
        color: #007f2a;
      }
      &.not-available {
        color: #dd0021;
      }
      &::before {
        content: '';
        width: 16px;
        height: 16px;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  `;
};

export default StoreListDetailsStyles;
